export default __webpack_public_path__ + "static/favicon-14587176faf1f35ef5992fc99f9809e9.png";